type Stat = {
  description: string;
  stat?: string;
};

const STATS: Stat[] = [
  {
    description: 'Season start date',
    stat: 'Aug. 8',
  },
  {
    description: 'NFL win rate since 2017',
    stat: '59.43%',
  },
  {
    description: 'NFL units won since 2017',
    stat: '+51.95',
  },
  // {
  //   description: 'Win rate last 5 years',
  //   stat: '54.97%',
  // },
];

export default function Stats() {
  return (
    <div className="w-full border-t border-zinc-700/80 bg-zinc-950/50 py-8">
      <div className="mb-8 pl-8 font-semibold text-white">
        RAS is a favorite to win this NFL season
      </div>
      <dl className="grid w-full grid-cols-3 text-white">
        {STATS.map(({ stat, description }, index) => (
          <div key={index} className="w-full py-6 text-left sm:py-0 md:px-8 lg:w-fit">
            <div className="space-y-2">
              <dd className="text-4xl font-semibold tracking-tight text-white">{stat}</dd>
              <dt className="text-xs font-semibold leading-5 text-zinc-400">{description}</dt>
            </div>
          </div>
        ))}
      </dl>
    </div>
  );
}
